/* globals chrome, navigator */

// TODO: move this to Device utils package!

/**
 * Returns true if the browser is:
 * 1) Internet Explorer
 * 2) Non-Chromium versions of Edge
 * NOTE: Only works for client side code.
 */
export const isLegacyBrowser = () => {
    const userAgent = getUserAgent();
    return isInternetExplorer(userAgent) || isNonChromiumEdge(userAgent);
};

export const getUserAgent = () => {
    return typeof navigator !== 'undefined' &&
        typeof navigator.userAgent === 'string'
        ? navigator.userAgent
        : 'unknown';
};

export const isInternetExplorer = (userAgent) => {
    // This should cover IE and IE mobile
    return /msie|trident/.test(userAgent.toLowerCase());
};

/**
 * Returns true for non chromium versions of edge. The logic for this can vary depending on the source,
 * but I have found that Twilio's way is the most consistent.
 * Microsoft claim that if the user agent has 'edg' instead of 'edge' then you can ensure it's the chromium version. But I have found evidence to the contrary in prod.
 * Here we determine that chromium edge is running if all of these conditions are satisfied:
 * 1) User agent contains 'Chrome' or 'CriOS'
 * 2) User agent contains 'Edge'
 * 3) Chrome and Chrome runtime objects are both defined globally - non chromium edge can still have the chrome object but not the runtime prop.
 * Reference links:
 * https://docs.microsoft.com/en-us/microsoft-edge/web-platform/user-agent-guidance#user-agent-strings
 * https://github.com/twilio/twilio-video.js/blob/08548605d9f173e77145d3f3fc3d2928cc59d4a0/lib/util/support.js#L60
 * https://github.com/twilio/twilio-webrtc.js/blob/d535165d0aa4893e40840497d51bb92eb57d01d2/lib/util/index.js#L145
 * @param {string} userAgent
 */
export const isNonChromiumEdge = (userAgent) => {
    // UserAgent with "edg" means it runs on Chromium.
    return (
        /Chrome|CriOS/.test(userAgent) &&
        /Edge/.test(userAgent) &&
        (typeof chrome === 'undefined' || typeof chrome.runtime === 'undefined')
    );
};
